import * as t from 'io-ts';
import { DateFromISOString } from 'io-ts-types/lib/DateFromISOString';

export const lastViewedSchema = t.type({
  viewed_at: DateFromISOString
},'lastViewedSchema');
export type LastViewedType = t.TypeOf<typeof lastViewedSchema>;
